import React, {Component} from 'react';
import PeopleAddContainer from "../../../containers/AdminPanel/People/PeopleAddContainer";
import PeopleInstructorsContainer from "../../../containers/AdminPanel/People/PeopleInstructorsContainer";
import PeopleStudentsContainer from "../../../containers/AdminPanel/People/PeopleStudentsContainer";
import {Link} from 'react-router-dom';

class PeopleManager extends Component {

    //Renders
    renderTitle = () => (
        <div className="bg-light lter b-b wrapper-md">
            <div className="row">
                <div className="col-sm12 col-xs-12">
                    <h1 className="m-n font-thin h3 text-black">People Manager</h1>
                    <small className="text-muted">Access management to the portal</small>
                </div>
            </div>
        </div>
    );

    renderNavigationLinks = () => (
        <ul className="nav nav-tabs bg-white">
            {this.renderLink('', 'course-admin', 'Courses', 'All Courses')}
            {this.renderLink('', 'strategy', 'Onboarding', 'Setup Onboarding')}
            {this.renderLink('active', 'people', 'People', 'Access Manager')}
            {this.renderLink('', 'settings-admin', 'Settings', 'Updates')}
            <li className="pull-right">
                <a href="#" style={{paddingRight: 10}}>
                    <div className="font-24 text-orange">
                        <i className="zmdi zmdi-plus-circle"/>
                    </div>
                </a>
            </li>
        </ul>
    );

    renderLink = (className, link, title ,subTitle) => (
        <li
            className={className}
        >
            <Link to={link}>
                {title}
                <span>
                    {subTitle}
                </span>
            </Link>
        </li>
    );

    renderNavigationTabs = () => (
        <ul className="nav nav-tabs">
            {this.renderTab('active', '#add_people_tab', 'Add')}
            {this.renderTab('', '#instructors_manager_tab', 'Instructors')}
            {this.renderTab('', '#students_manager_tab', 'Students')}
        </ul>
    );

    renderTab = (className, link, title) => (
        <li
            className={className}
        >
            <a
                href={link}
                data-toggle="tab"
            >
                {title}
            </a>
        </li>
    );

    render() {
        return (
            <div className="content-wrapper" id="content-container">
                {this.renderTitle()}
                <section className="content no-padding">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="nav-tabs-custom no-bg">
                                {this.renderNavigationLinks()}
                                <div className="tab-content no-bg no-padding">
                                    <div className="tab-pane active" id="tab_2">
                                        <div className="nav-tabs-custom no-bg inner-tabs">
                                            {this.renderNavigationTabs()}
                                            <div className="tab-content no-bg no-padding">
                                                <div className="tab-pane active" id="add_people_tab">
                                                    <PeopleAddContainer/>
                                                </div>
                                                <div className="tab-pane" id="instructors_manager_tab">
                                                    <PeopleInstructorsContainer/>
                                                </div>
                                                <div className="tab-pane" id="students_manager_tab">
                                                    <PeopleStudentsContainer/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default PeopleManager;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/People/PeopleManager.js